import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../../translations/translations_school';
import classnames from 'classnames';
import validator from 'validator';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {updateSchool} from '../../../actions';
import {getSchoolsTypes, getSchoolsProgrammes, getSchoolsDegrees, getSchoolsCertifications} from '../../../../Schools/actions';
import {EditorState, convertToRaw, ContentState} from 'draft-js';
import {Editor} from 'react-draft-wysiwyg';
import '../../../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import htmlToDraft from 'html-to-draftjs';
import {stateFromHTML} from 'draft-js-import-html';
import {stateToHTML} from 'draft-js-export-html';
import LoadingSpinner from '../../../../Layout/components/LoadingSpinner';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Avatar from '@material-ui/core/Avatar';
import SmartphoneIcon from '@material-ui/icons/Smartphone';
import TabletIcon from '@material-ui/icons/Tablet';
import DesktopIcon from '@material-ui/icons/DesktopWindows';
import LaptopIcon from '@material-ui/icons/Laptop';
import DevicesOtherIcon from '@material-ui/icons/DevicesOther';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "@material-ui/core/TextField";
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Tooltip from '@material-ui/core/Tooltip';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import axios from '../../../../../app/api/axios';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class DashboardSchoolDetails extends Component {
    state = {
        errors: {},
        expanded: null,
        openDialogConfirmation: false,
        openDialogUpload: false,
        openSnackbarSuccess: false,
        formConfirmation: false,
        noFieldsUpdated: true,
        uploadAction: '',
        uploadImage: '',
        uploadProgress: 0,
        uploadErrors: [],
        selectedImage: null,
        checkedTypes: [],
        checkedProgrammes: [],
        checkedDegrees: [],
        checkedCertifications: [],
        title: this.props.school.title,
        direction: this.props.school.direction,
        school_fees_min: this.props.school.school_fees_min,
        school_fees_max: this.props.school.school_fees_max,
        number_students: this.props.school.number_students,
        address_line1: this.props.school.address_line1,
        address_line2: this.props.school.address_line2,
        address_postal_code: this.props.school.address_postal_code,
        address_city: this.props.school.address_city,
        logo: this.props.school.logo,
        background_image: this.props.school.background_image,
        phone: this.props.school.phone,
        fax: this.props.school.fax,
        contact: this.props.school.contact,
        website: this.props.school.facebook,
        facebook: this.props.school.facebook,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidMount() {
        // Get the taxonomies terms
        this.props.getSchoolsTypes();
        this.props.getSchoolsProgrammes();
        this.props.getSchoolsDegrees();
        this.props.getSchoolsCertifications();

        // Init the WYSIWYG editor(s)

        this.initEditorState(this.props.school.content, 'presentation');
        this.initEditorState(this.props.school.school_fees_description, 'school_fees_description');
    }

    initEditorState(field, state) {
        let elementState;

        if (field && field.length > 0) {
            const contentState = stateFromHTML(field);
            elementState = EditorState.createWithContent(contentState);
        } else {
            elementState = EditorState.createEmpty();
        }

        this.setState({
            [state]: elementState,
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const {school, types, programmes, degrees, certifications, taxonomiesLoading} = this.props;

        if (!taxonomiesLoading && (prevProps.types !== types || prevProps.programmes !== programmes || prevProps.degrees !== degrees || prevProps.certifications !== certifications)) {
            if (types !== null && (Array.isArray(school.types) && school.types.length > 0)) {
                const {checkedTypes} = this.state;
                const newChecked = [...checkedTypes];

                school.types.forEach((item, index) => {
                    const currentIndex = checkedTypes.indexOf(item.term_id);
                    if (currentIndex === -1) {
                        newChecked.push(item.term_id);
                    }
                });

                this.setState({
                    checkedTypes: newChecked,
                });
            }

            if (programmes !== null && (Array.isArray(school.programmes) && school.programmes.length > 0)) {
                const {checkedProgrammes} = this.state;
                const newChecked = [...checkedProgrammes];

                school.programmes.forEach((item, index) => {
                    const currentIndex = checkedProgrammes.indexOf(item.term_id);
                    if (currentIndex === -1) {
                        newChecked.push(item.term_id);
                    }
                });

                this.setState({
                    checkedProgrammes: newChecked,
                });
            }

            if (degrees !== null && (Array.isArray(school.degrees) && school.degrees.length > 0)) {
                const {checkedDegrees} = this.state;
                const newChecked = [...checkedDegrees];

                school.degrees.forEach((item, index) => {
                    const currentIndex = checkedDegrees.indexOf(item.term_id);
                    if (currentIndex === -1) {
                        newChecked.push(item.term_id);
                    }
                });

                this.setState({
                    checkedDegrees: newChecked,
                });
            }

            if (certifications !== null && (Array.isArray(school.certifications) && school.certifications.length > 0)) {
                const {checkedCertifications} = this.state;
                const newChecked = [...checkedCertifications];

                school.certifications.forEach((item, index) => {
                    const currentIndex = checkedCertifications.indexOf(item.term_id);
                    if (currentIndex === -1) {
                        newChecked.push(item.term_id);
                    }
                });

                this.setState({
                    checkedCertifications: newChecked,
                });
            }
        }

        if (prevProps.errors !== this.props.errors) {
            this.setState({
                errors: this.props.errors,
            });
        }
    }

    handleChangePanel = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    };

    handleChange = name => e => {
        const value = (e.target.type === 'checkbox') ? e.target.checked : e.target.value;

        this.setState({
            [name]: value,
        }, () => this.validateFieldsAndDisplayErrors([name]));
    };

    handleEditorStateChange = name => editorState => {
        this.setState({
            [name]: editorState,
        }, () => this.validateFieldsAndDisplayErrors([name]));
    };

    handleToggleTypes = value => () => {
        const {checkedTypes} = this.state;
        const currentIndex = checkedTypes.indexOf(value);
        const newChecked = [...checkedTypes];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        this.setState({
            checkedTypes: newChecked,
        });
    };

    handleToggleProgrammes = value => () => {
        const {checkedProgrammes} = this.state;
        const currentIndex = checkedProgrammes.indexOf(value);
        const newChecked = [...checkedProgrammes];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        this.setState({
            checkedProgrammes: newChecked,
        });
    };

    handleToggleDegrees = value => () => {
        const {checkedDegrees} = this.state;
        const currentIndex = checkedDegrees.indexOf(value);
        const newChecked = [...checkedDegrees];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        this.setState({
            checkedDegrees: newChecked,
        });
    };

    handleToggleCertifications = value => () => {
        const {checkedCertifications} = this.state;
        const currentIndex = checkedCertifications.indexOf(value);
        const newChecked = [...checkedCertifications];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        this.setState({
            checkedCertifications: newChecked,
        });
    };

    handleCloseSnackbar = (e) => {
        this.setState({
            openSnackbarSuccess: false
        });
    };

    handleClickConfirmSubmit = () => {
        this.setState({
            openDialogConfirmation: false,
            formConfirmation: true,
        }, () => {
            this.handleClickFormSubmit();
        });
    };

    handleCloseConfirmationDialog = () => {
        this.setState({
            openDialogConfirmation: false
        });
    };

    handleCloseUploadDialog = () => {
        this.setState({
            uploadAction: '',
            uploadImage: '',
            openDialogUpload: false
        });
    };

    handleClickAddImage = (action, image) => (e) => {
        e.preventDefault();

        this.setState({
            uploadAction: action,
            uploadImage: image,
            openDialogUpload: true
        });
    };

    handleUploadImage = (e) => {
        e.preventDefault();

        const {school} = this.props;

        const data = new FormData();
        data.append('image', this.state.selectedImage, this.state.selectedImage.name);

        axios.post('agep/v1/school/' + school.slug + '/upload/' + this.state.uploadImage, data, {
                onUploadProgress: ProgressEvent => {
                    this.setState({
                        uploadProgress: (ProgressEvent.loaded / ProgressEvent.total) * 100,
                    })
                },
            })
            .then(res => {
                //console.log('upload then');
                //console.log(res.statusText)
            })
            .catch(err => {
                //console.log('upload with error');
                //console.log(err.response.data);
            });
    };

    handleSelectedImage = (e) => {
        //console.log('dans handleSelectedImage()');
        //console.log(e.target.files);

        const file = e.target.files[0];

        let errs = [];

        const types = ['image/png', 'image/jpeg', 'image/gif'];

        if (types.every(type => file.type !== type)) {
            errs.push(`'${file.type}' is not a supported format`);
        }

        if (file.size > 0 && (file.size / 1024 / 1024) > 10) { // 10 MB
            errs.push(`'${file.name}' is too large, please pick a smaller file`);
        }

        if (errs.length) {
            this.setState({
                uploadErrors: errs,
                uploadProgress: 0,
            });

            // TODO
            console.log('image has errors');
            console.log(errs);
        } else {
            this.setState({
                selectedImage: file,
                uploadProgress: 0,
            });
        }
    };

    handleClickFormSubmit = () => {
        const {errors} = this.state;
        const errorsData = (errors.hasOwnProperty('data')) ? errors.data : {};

        if (Object.keys(errorsData).length === 0) {
            if (this.state.formConfirmation) {
                const presentationContentState = this.state.presentation.getCurrentContent();
                let presentationHtml = stateToHTML(presentationContentState);

                const schoolFeesDescriptionContentState = this.state.school_fees_description.getCurrentContent();
                let schoolFeesDescriptionHtml = stateToHTML(schoolFeesDescriptionContentState);

                let data = {
                    title: this.state.title,
                    direction: this.state.direction,
                    school_fees_min: this.state.school_fees_min,
                    school_fees_max: this.state.school_fees_max,
                    school_fees_description: schoolFeesDescriptionHtml,
                    number_students: this.state.number_students,
                    address_line1: this.state.address_line1,
                    address_line2: this.state.address_line2,
                    address_postal_code: this.state.address_postal_code,
                    address_city: this.state.address_city,
                    phone: this.state.phone,
                    fax: this.state.fax,
                    contact: this.state.contact,
                    website: this.state.facebook,
                    facebook: this.state.facebook,
                    presentation: presentationHtml,
                    types: this.state.checkedTypes,
                    programmes: this.state.checkedProgrammes,
                    degrees: this.state.checkedDegrees,
                    certifications: this.state.checkedCertifications,
                    //logo: this.state.logo,
                    //background_image: this.state.background_image,
                };

                this.props.updateSchool(this.props.school.slug, data);
            } else {
                this.setState({
                    openDialogConfirmation: true
                });
            }
        }
    };

    validateFieldsAndDisplayErrors = (fields = []) => {
        const {errors} = this.state;
        const errorsData = (errors.hasOwnProperty('data')) ? errors.data : {};
        let hasErrors = false;

        for (let i = 0, len = fields.length; i < len; i++) {
            let error = this.validateField(fields[i]);

            if (error !== null) {
                hasErrors = true;
                errorsData[fields[i]] = error;
            } else {
                if (errorsData.hasOwnProperty(fields[i])) {
                    delete errorsData[fields[i]];
                }
            }
        }

        if (this.state.noFieldsUpdated) {
            this.setState({
                noFieldsUpdated: false,
                errors: {
                    ...errors,
                    data: errorsData,
                }
            });
        } else {
            this.setState({
                errors: {
                    ...errors,
                    data: errorsData,
                }
            });
        }

        return hasErrors;
    };

    validateField = (field) => {
        let error = null;

        switch (field) {
            case 'title':
                if (validator.isEmpty(this.state.title)) {
                    error = this.props.translate('dashboard_school.validate_title_required');
                } else if (this.state.title.length <= 2) {
                    error = this.props.translate('dashboard_school.validate_title_too_short');
                }
                break;
            case 'phone':
                if (validator.isEmpty(this.state.phone)) {
                    error = this.props.translate('dashboard_school.validate_phone_required');
                } else if (this.state.phone.length <= 2) {
                    error = this.props.translate('dashboard_school.validate_phone_too_short');
                }
                break;
            case 'direction':
                if (validator.isEmpty(this.state.direction)) {
                    error = this.props.translate('dashboard_school.validate_direction_required');
                }
                break;
            case 'number_students':
                break;
            case 'school_fees_min':
                if (!validator.isEmpty(this.state.school_fees_min) && !validator.isNumeric(this.state.school_fees_min)) {
                    error = this.props.translate('dashboard_school.validate_school_fees_number');
                }
                break;
            case 'school_fees_max':
                if (!validator.isEmpty(this.state.school_fees_max) && !validator.isNumeric(this.state.school_fees_max)) {
                    error = this.props.translate('dashboard_school.validate_school_fees_number');
                }
                break;
            case 'school_fees_description':
                if (this.state.phone.school_fees_description > 2000) {
                    error = this.props.translate('dashboard_school.validate_school_fees_description_too_long');
                }
                break;
            case 'address_line1':
                if (validator.isEmpty(this.state.address_line1)) {
                    error = this.props.translate('dashboard_school.validate_address_line1_required');
                }
                break;
            case 'address_postal_code':
                if (validator.isEmpty(this.state.address_postal_code)) {
                    error = this.props.translate('dashboard_school.validate_postal_code_required');
                } else if (this.state.address_postal_code.length > 10) {
                    error = this.props.translate('dashboard_school.validate_postal_code_too_long');
                } else if (this.state.address_postal_code.length <= 2) {
                    error = this.props.translate('dashboard_school.validate_postal_code_too_short');
                }
                break;
            case 'address_city':
                if (validator.isEmpty(this.state.address_city)) {
                    error = this.props.translate('dashboard_school.validate_city_required');
                }
                break;
            case 'fax':
                break;
            case 'contact':
                if (!validator.isEmpty(this.state.contact) && !validator.isEmail(this.state.contact)) {
                    error = this.props.translate('dashboard_school.validate_email_not_valid');
                }
                break;
            case 'website':
                if (!validator.isEmpty(this.state.website) && !validator.isURL(this.state.website)) {
                    error = this.props.translate('dashboard_school.validate_website_not_valid');
                }
                break;
            case 'facebook':
                if (!validator.isEmpty(this.state.facebook) && !validator.isURL(this.state.facebook)) {
                    error = this.props.translate('dashboard_school.validate_facebook_not_valid');
                }
                break;
            case 'presentation':
                if (this.state.presentation) {
                    // Get the content from the WYSIWYG
                    const hasText = this.state.presentation.getCurrentContent().hasText();

                    if (!hasText) {
                        error = this.props.translate('dashboard_school.validate_presentation_required');
                    }
                }
                break;
            default:
                break;
        }

        return error;
    };

    render() {
        const {school, types, programmes, degrees, certifications, taxonomiesLoading} = this.props;
        const {updateSchoolLoading, schoolUpdated} = this.props.dashboard;
        const {expanded, noFieldsUpdated, errors, uploadProgress, uploadErrors} = this.state;
        const errorsData = (errors.hasOwnProperty('data')) ? errors.data : {};

        let submitButtonDisabled = false;

        if (taxonomiesLoading || updateSchoolLoading || noFieldsUpdated || Object.keys(errorsData).length > 0) {
            submitButtonDisabled = true;
        }

        if (schoolUpdated) {
            return (
                <div className="success_sending">
                    <h4><Translate id="dashboard_school.success_sending_title" /></h4>
                    <Translate id="dashboard_school.success_sending_message" />
                </div>
            );
        }

        return (
            <Fragment>
                <form autoComplete="off">
                    <section className="section-setting mt-20 mb-60">
                        <h2 className="title">
                            <Translate id="dashboard_school.title_section_informations_generales" />
                        </h2>

                        <ExpansionPanel expanded={expanded === 'panel10'} onChange={this.handleChangePanel('panel10')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel10'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_nom_ecole" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.title ? true : false}>
                                    <InputLabel htmlFor="title" className="form-label">
                                        <Translate id="dashboard_school.field_title" /> *
                                    </InputLabel>
                                    <Input id="title" value={this.state.title} onChange={this.handleChange('title')} className="form-input" />
                                    {errorsData.title && (<FormHelperText className="form-helper">{errorsData.title}</FormHelperText>)}
                                </FormControl>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel expanded={expanded === 'panel11'} onChange={this.handleChangePanel('panel11')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel11'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_presentation" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.presentation ? true : false}>
                                    <Editor
                                        editorState={this.state.presentation}
                                        onEditorStateChange={this.handleEditorStateChange('presentation')}
                                        toolbar={{
                                            options: ['inline', 'blockType', 'list', 'link', 'remove', 'history'],
                                            inline: {
                                                options: ['bold', 'italic', 'underline'],
                                            },
                                            blockType: {
                                                options: ['Normal', 'H3', 'H4'],
                                            },
                                            list: {
                                                options: ['unordered', 'ordered'],
                                            }
                                        }}
                                    />
                                    {errorsData.presentation && (<FormHelperText className="form-helper">{errorsData.presentation}</FormHelperText>)}
                                </FormControl>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    </section>

                    <section className="section-setting mb-60">
                        <h2 className="title">
                            <Translate id="dashboard_school.title_section_caracteristiques" />
                        </h2>

                        <ExpansionPanel expanded={expanded === 'panel20'} onChange={this.handleChangePanel('panel20')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel20'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_diplomes" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                {(degrees !== null && !taxonomiesLoading) &&
                                    <List>
                                        {degrees.map(item => {
                                            return (
                                                <ListItem key={item.term_id} role={undefined} button disableGutters onClick={this.handleToggleDegrees(item.term_id)}>
                                                    <Checkbox
                                                        checked={this.state.checkedDegrees.indexOf(item.term_id) !== -1}
                                                        tabIndex={-1}
                                                        disableRipple
                                                    />
                                                    <ListItemText primary={item.name}/>
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                }
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel expanded={expanded === 'panel21'} onChange={this.handleChangePanel('panel21')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel21'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_certifications" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                {(certifications !== null && !taxonomiesLoading) &&
                                    <List>
                                        {certifications.map(item => {
                                            return (
                                                <ListItem key={item.term_id} role={undefined} button disableGutters onClick={this.handleToggleCertifications(item.term_id)}>
                                                    <Checkbox
                                                        checked={this.state.checkedCertifications.indexOf(item.term_id) !== -1}
                                                        tabIndex={-1}
                                                        disableRipple
                                                    />
                                                    <ListItemText primary={item.name}/>
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                }
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel expanded={expanded === 'panel22'} onChange={this.handleChangePanel('panel22')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel22'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_type_ecole" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                {(types !== null && !taxonomiesLoading) &&
                                    <List>
                                        {types.map(item => {
                                            return (
                                                <ListItem key={item.term_id} role={undefined} button disableGutters onClick={this.handleToggleTypes(item.term_id)}>
                                                    <Checkbox
                                                        checked={this.state.checkedTypes.indexOf(item.term_id) !== -1}
                                                        tabIndex={-1}
                                                        disableRipple
                                                    />
                                                    <ListItemText primary={item.name}/>
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                }
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel expanded={expanded === 'panel23'} onChange={this.handleChangePanel('panel23')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel23'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_programmes" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                {(programmes !== null && !taxonomiesLoading) &&
                                    <List>
                                        {programmes.map(item => {
                                            return (
                                                <ListItem key={item.term_id} role={undefined} button disableGutters onClick={this.handleToggleProgrammes(item.term_id)}>
                                                    <Checkbox
                                                        checked={this.state.checkedProgrammes.indexOf(item.term_id) !== -1}
                                                        tabIndex={-1}
                                                        disableRipple
                                                    />
                                                    <ListItemText primary={item.name}/>
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                }
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel expanded={expanded === 'panel24'} onChange={this.handleChangePanel('panel24')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel24'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_nombre_eleves" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.number_students ? true : false}>
                                    <InputLabel htmlFor="number_students" className="form-label">
                                        <Translate id="dashboard_school.field_number_students" />
                                    </InputLabel>
                                    <Input id="number_students" value={this.state.number_students} onChange={this.handleChange('number_students')} className="form-input" type="number" />
                                    {errorsData.number_students && (<FormHelperText className="form-helper">{errorsData.number_students}</FormHelperText>)}
                                </FormControl>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    </section>

                    <section className="section-setting mb-60">
                        <h2 className="title">
                            <Translate id="dashboard_school.title_section_ecolage" />
                        </h2>

                        <ExpansionPanel expanded={expanded === 'panel30'} onChange={this.handleChangePanel('panel30')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel30'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_ecolage_min" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.school_fees_min ? true : false}>
                                    <InputLabel htmlFor="school_fees_min" className="form-label">
                                        <Translate id="dashboard_school.school_fees_sum_chf" />
                                    </InputLabel>
                                    <Input id="school_fees_min" value={this.state.school_fees_min} onChange={this.handleChange('school_fees_min')} className="form-input" type="number" />
                                    {errorsData.school_fees_min && (<FormHelperText className="form-helper">{errorsData.school_fees_min}</FormHelperText>)}
                                </FormControl>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel expanded={expanded === 'panel31'} onChange={this.handleChangePanel('panel31')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel31'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_ecolage_max" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.school_fees_max ? true : false}>
                                    <InputLabel htmlFor="school_fees_max" className="form-label">
                                        <Translate id="dashboard_school.school_fees_sum_chf" />
                                    </InputLabel>
                                    <Input id="school_fees_max" value={this.state.school_fees_max} onChange={this.handleChange('school_fees_max')} className="form-input" type="number" />
                                    {errorsData.school_fees_max && (<FormHelperText className="form-helper">{errorsData.school_fees_max}</FormHelperText>)}
                                </FormControl>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel expanded={expanded === 'panel32'} onChange={this.handleChangePanel('panel32')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel32'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_ecolage_description" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.school_fees_description ? true : false}>
                                    <Editor
                                        editorState={this.state.school_fees_description}
                                        onEditorStateChange={this.handleEditorStateChange('school_fees_description')}
                                        toolbar={{
                                            options: ['inline', 'blockType', 'list', 'link', 'remove', 'history'],
                                            inline: {
                                                options: ['bold', 'italic', 'underline'],
                                            },
                                            blockType: {
                                                options: ['Normal', 'H3', 'H4'],
                                            },
                                            list: {
                                                options: ['unordered', 'ordered'],
                                            }
                                        }}
                                    />
                                    {errorsData.school_fees_description && (<FormHelperText className="form-helper">{errorsData.school_fees_description}</FormHelperText>)}
                                </FormControl>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    </section>

                    <section className="section-setting mb-60">
                        <h2 className="title">
                            <Translate id="dashboard_school.title_section_coordonnees" />
                        </h2>

                        <ExpansionPanel expanded={expanded === 'panel40'} onChange={this.handleChangePanel('panel40')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel40'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_adresse" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_line1 ? true : false}>
                                    <InputLabel htmlFor="address_line1" className="form-label">
                                        <Translate id="dashboard_school.field_address_line1" /> *
                                    </InputLabel>
                                    <Input id="address_line1" value={this.state.address_line1} onChange={this.handleChange('address_line1')} className="form-input" />
                                    {errorsData.address_line1 && (<FormHelperText className="form-helper">{errorsData.address_line1}</FormHelperText>)}
                                </FormControl>

                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_line2 ? true : false}>
                                    <InputLabel htmlFor="address_line2" className="form-label">
                                        <Translate id="dashboard_school.field_address_line2" />
                                    </InputLabel>
                                    <Input id="address_line2" value={this.state.address_line2} onChange={this.handleChange('address_line2')} className="form-input" />
                                    {errorsData.address_line2 && (<FormHelperText className="form-helper">{errorsData.address_line2}</FormHelperText>)}
                                </FormControl>

                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_postal_code ? true : false}>
                                    <InputLabel htmlFor="address_postal_code" className="form-label">
                                        <Translate id="dashboard_school.field_address_postal_code" /> *
                                    </InputLabel>
                                    <Input id="address_postal_code" value={this.state.address_postal_code} onChange={this.handleChange('address_postal_code')} className="form-input" />
                                    {errorsData.address_postal_code && (<FormHelperText className="form-helper">{errorsData.address_postal_code}</FormHelperText>)}
                                </FormControl>

                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_city ? true : false}>
                                    <InputLabel htmlFor="address_city" className="form-label">
                                        <Translate id="dashboard_school.field_address_city" /> *
                                    </InputLabel>
                                    <Input id="address_city" value={this.state.address_city} onChange={this.handleChange('address_city')} className="form-input" />
                                    {errorsData.address_city && (<FormHelperText className="form-helper">{errorsData.address_city}</FormHelperText>)}
                                </FormControl>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel expanded={expanded === 'panel41'} onChange={this.handleChangePanel('panel41')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel41'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_direction" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.direction ? true : false}>
                                    <InputLabel htmlFor="direction" className="form-label">
                                        <Translate id="dashboard_school.field_direction" /> *
                                    </InputLabel>
                                    <Input id="direction" value={this.state.direction} onChange={this.handleChange('direction')} className="form-input" />
                                    {errorsData.direction && (<FormHelperText className="form-helper">{errorsData.direction}</FormHelperText>)}
                                </FormControl>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel expanded={expanded === 'panel42'} onChange={this.handleChangePanel('panel42')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel42'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_telephone" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.phone ? true : false}>
                                    <InputLabel htmlFor="phone" className="form-label">
                                        <Translate id="dashboard_school.field_phone" /> *
                                    </InputLabel>
                                    <Input id="phone" value={this.state.phone} onChange={this.handleChange('phone')} className="form-input" />
                                    {errorsData.phone && (<FormHelperText className="form-helper">{errorsData.phone}</FormHelperText>)}
                                </FormControl>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel expanded={expanded === 'panel43'} onChange={this.handleChangePanel('panel43')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel43'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_fax" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.fax ? true : false}>
                                    <InputLabel htmlFor="fax" className="form-label">
                                        <Translate id="dashboard_school.field_fax" />
                                    </InputLabel>
                                    <Input id="fax" value={this.state.fax} onChange={this.handleChange('fax')} className="form-input" />
                                    {errorsData.fax && (<FormHelperText className="form-helper">{errorsData.fax}</FormHelperText>)}
                                </FormControl>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel expanded={expanded === 'panel44'} onChange={this.handleChangePanel('panel44')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel44'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_email" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.contact ? true : false}>
                                    <InputLabel htmlFor="contact" className="form-label">
                                        <Translate id="dashboard_school.field_contact" />
                                    </InputLabel>
                                    <Input id="contact" value={this.state.contact} onChange={this.handleChange('contact')} className="form-input" type="email" />
                                    {errorsData.contact && (<FormHelperText className="form-helper">{errorsData.contact}</FormHelperText>)}
                                </FormControl>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel expanded={expanded === 'panel45'} onChange={this.handleChangePanel('panel45')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel45'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_site_internet" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.website ? true : false}>
                                    <InputLabel htmlFor="website" className="form-label">
                                        <Translate id="dashboard_school.field_website" />
                                    </InputLabel>
                                    <Input id="website" value={this.state.website} onChange={this.handleChange('website')} className="form-input" />
                                    {errorsData.website && (<FormHelperText className="form-helper">{errorsData.website}</FormHelperText>)}
                                </FormControl>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel expanded={expanded === 'panel46'} onChange={this.handleChangePanel('panel46')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel46'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_facebook" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.facebook ? true : false}>
                                    <InputLabel htmlFor="facebook" className="form-label">
                                        <Translate id="dashboard_school.field_facebook" />
                                    </InputLabel>
                                    <Input id="facebook" value={this.state.facebook} onChange={this.handleChange('facebook')} className="form-input" />
                                    {errorsData.facebook && (<FormHelperText className="form-helper">{errorsData.facebook}</FormHelperText>)}
                                </FormControl>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    </section>

                    <section className="section-setting mb-60">
                        <h2 className="title">
                            <Translate id="dashboard_school.title_section_medias" />
                        </h2>

                        <ExpansionPanel expanded={expanded === 'panel50'} onChange={this.handleChangePanel('panel50')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel50'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_logo" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                {(school.logo && school.logo.listing) ? (
                                    <Fragment>
                                        <Button variant="contained" color="primary" className="btn-mui" href={school.logo.listing} target="_blank">
                                            <Translate id="dashboard_school.button_view_image" />
                                        </Button>
                                        &nbsp;&nbsp;
                                        <Button disabled={true} variant="contained" color="primary" className="btn-mui btn-replace-image" onClick={this.handleClickAddImage('replace', 'logo')}>
                                            <Translate id="dashboard_school.button_replace_image" />
                                            <CloudUploadIcon className="icon" />
                                        </Button>
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        <div className="message">
                                            <Translate id="dashboard_school.notice_no_logo" />
                                        </div>
                                        <Button disabled={true} variant="contained" color="primary" className="btn-mui btn-add-image"  onClick={this.handleClickAddImage('add', 'logo')}>
                                            <Translate id="dashboard_school.button_add_image" />
                                            <CloudUploadIcon className="icon" />
                                        </Button>
                                    </Fragment>
                                )}
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel expanded={expanded === 'panel51'} onChange={this.handleChangePanel('panel51')} className={classnames('expansion-panel', {
                            'expanded': (expanded === 'panel51'),
                        })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="panel-heading">
                                    <Translate id="dashboard_school.panel_title_image_couverture" />
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="panel-details">
                                {(school.background_image && school.background_image.details) ? (
                                    <Fragment>
                                        <Button variant="contained" color="primary" className="btn-mui" href={school.background_image.details} target="_blank">
                                            <Translate id="dashboard_school.button_view_image" />
                                        </Button>
                                        &nbsp;&nbsp;
                                        <Button disabled={true} variant="contained" color="primary" className="btn-mui btn-replace-image" onClick={this.handleClickAddImage('replace', 'background_image')}>
                                            <Translate id="dashboard_school.button_replace_image" />
                                            <CloudUploadIcon className="icon" />
                                        </Button>
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        <div className="message">
                                            <Translate id="dashboard_school.notice_no_background_image" />
                                        </div>
                                        <Button disabled={true} variant="contained" color="primary" className="btn-mui btn-add-image"  onClick={this.handleClickAddImage('add', 'background_image')}>
                                            <Translate id="dashboard_school.button_add_image" />
                                            <CloudUploadIcon className="icon" />
                                        </Button>
                                    </Fragment>
                                )}
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    </section>
                </form>

                <div className="row row-bottom align-items-center">
                    <div className="col col-left col-6">
                        <div className="notice">
                            <Translate id="dashboard_school.asterisk" />
                        </div>
                    </div>
                    <div className="col col-right col-6">
                        {submitButtonDisabled ? (
                            <Tooltip title={this.props.translate('dashboard_school.button_submit_disabled_notice')}>
                                <span>
                                    <Button variant="contained" color="primary" size="medium" className="btn-submit" type="submit" onClick={this.handleClickFormSubmit} disabled={submitButtonDisabled}>
                                        <Translate id="dashboard_school.button_submit" />
                                    </Button>
                                </span>
                            </Tooltip>
                        ) : (
                            <Button variant="contained" color="primary" size="medium" className="btn-submit" type="submit" onClick={this.handleClickFormSubmit} disabled={submitButtonDisabled}>
                                <Translate id="dashboard_school.button_submit" />
                            </Button>
                        )}
                    </div>
                </div>

                <Dialog
                    open={this.state.openDialogConfirmation}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handleCloseConfirmationDialog}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">
                        <Translate id="dashboard_school.dialog_confirmation_title" />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            <Translate id="dashboard_school.dialog_confirmation_description" />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseConfirmationDialog} color="primary">
                            <Translate id="dashboard_school.dialog_confirmation_button_cancel" />
                        </Button>
                        <Button onClick={this.handleClickConfirmSubmit} color="primary">
                            <Translate id="dashboard_school.dialog_confirmation_button_confirm" />
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.openDialogUpload}
                    onClose={this.handleCloseUploadDialog}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">
                        {this.state.uploadAction === 'replace' ? (
                            <Translate id="dashboard_school.dialog_upload_title_replace" />
                        ) : (
                            <Translate id="dashboard_school.dialog_upload_title_add" />
                        )}
                    </DialogTitle>
                    <DialogContent>
                        <div className="notice">
                            <p>Extensions : PNG, JPG ou GIF<br />Poids maxi : 20 Mo</p>
                        </div>

                        <input type="file" name="" onChange={this.handleSelectedImage} />

                        <div className="progress">
                            {(uploadProgress && (uploadProgress > 0 && uploadProgress < 100)) &&
                                <p>Progression : {uploadProgress} %</p>
                            }
                            {uploadProgress === 100 &&
                                <p>Transfert terminé.</p>
                            }
                        </div>

                        {(Array.isArray(uploadErrors) && uploadErrors > 0) &&
                            <div className="errors">
                                {uploadErrors.map(error => (
                                    <p>{error}</p>
                                ))}
                            </div>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseUploadDialog} color="primary">
                            <Translate id="dashboard_school.dialog_upload_button_cancel" />
                        </Button>
                        <Button onClick={this.handleUploadImage} color="primary">
                            <Translate id="dashboard_school.dialog_upload_button_confirm" />
                        </Button>
                    </DialogActions>
                </Dialog>

                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    open={this.state.openSnackbarSuccess}
                    autoHideDuration={5000}
                    onClose={this.handleCloseSnackbar}
                    ContentProps={{
                        'aria-describedby': 'message-success',
                    }}
                    message={<span id="message-success"><Translate id="dashboard_school.notice_school_request_sended" /></span>}
                    action={[
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            className="close"
                            onClick={this.handleCloseSnackbar}
                        >
                            <CloseIcon />
                        </IconButton>,
                    ]}
                />
            </Fragment>
        );
    }
}

DashboardSchoolDetails.propTypes = {
    school: PropTypes.object.isRequired,
    getSchoolsTypes: PropTypes.func.isRequired,
    getSchoolsProgrammes: PropTypes.func.isRequired,
    getSchoolsDegrees: PropTypes.func.isRequired,
    getSchoolsCertifications: PropTypes.func.isRequired,
    updateSchool: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    types: state.schools.types,
    programmes: state.schools.programmes,
    degrees: state.schools.degrees,
    certifications: state.schools.certifications,
    taxonomiesLoading: state.schools.taxonomiesLoading,
    dashboard: state.dashboard,
    errors: state.dashboard.updateSchoolErrors,
});

export default withRouter(connect(mapStateToProps, {getSchoolsTypes, getSchoolsProgrammes, getSchoolsDegrees, getSchoolsCertifications, updateSchool})(withLocalize(DashboardSchoolDetails)));


// WEBPACK FOOTER //
// ./src/features/Dashboard/components/Schools/Details/DashboardSchoolDetails.js